import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
    *{
        font-family: 'Lexend Deca', sans-serif;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        font-style: normal;
        font-weight: normal;
        font-size: 70px;
        text-decoration: none;
        
    }
`

export default GlobalStyle;